// Module
var code = `{{#}}
<a
  data-channel="ROUTE"
  data-page-id="{{pageId}}"
  data-topic-id="{{topicId}}"
  data-option-id="{{optionId}}"
  data-event-type="menuDrawer"
  data-event-prevent-default="true"
  class="nav link menu-drawer-link ds-link nav-level-{{navLevel}}"
  href="{{href}}"
  >{{title}}</a
>

{{/}}
`;
// Exports
module.exports = code;